export default "__VITE_ASSET__tU_GuC0z__"